import React from "react";

type ErrorBoundaryState = {
  hasError: boolean;
  errorMessage: string;
};

type ErrorBoundaryProps = React.PropsWithChildren<{}>;

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false,
    errorMessage: "",
  };

  public static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return {
      hasError: true,
      errorMessage: error?.message || "Unexpected error",
    };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error("[ErrorBoundary] Unhandled UI error", error, errorInfo);
  }

  private readonly handleReload = () => {
    window.location.reload();
  };

  public render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          background: "#f7f7f7",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "560px",
            background: "#fff",
            borderRadius: "12px",
            padding: "24px",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
            fontFamily: "inherit",
          }}
        >
          <h2 style={{ margin: "0 0 8px", color: "#d64f40" }}>Something went wrong</h2>
          <p style={{ margin: "0 0 16px", color: "#444" }}>
            The page crashed unexpectedly. Please reload and try again.
          </p>
          {this.state.errorMessage ? (
            <pre
              style={{
                margin: "0 0 16px",
                padding: "12px",
                borderRadius: "8px",
                background: "#fafafa",
                border: "1px solid #eee",
                color: "#555",
                overflowX: "auto",
                whiteSpace: "pre-wrap",
              }}
            >
              {this.state.errorMessage}
            </pre>
          ) : null}
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              border: "none",
              background: "#ec6f63",
              color: "#fff",
              padding: "10px 16px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;